import { PayloadAction } from "@reduxjs/toolkit";
import { createApi, createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { baseQuery, endpoints, formatErrors } from 'utils/api/endpoints';
import { UserProfileState } from "./types";


export const initialState: UserProfileState = {
  loading: false,
  error: null,
  success: false,
};

export const api = createApi({
  reducerPath: "userProfileApi",
  tagTypes: ['UserProfile'],
  baseQuery,
  tagTypes: ['UserProfile'],
  endpoints: builder => ({
    userProfileSetup : builder.mutation<any, any>({
      query:(body) =>({
        url: endpoints.providerProfileSetup.url,
        method: endpoints.providerProfileSetup.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
      invalidatesTags: ['UserProfile'],
    }),
    updateUserProfile : builder.mutation<any, any>({
      query: (body) => ({
        url: endpoints.userProfile.url,
        method: endpoints.userProfile.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    // get user profile 
    getUserProfile : builder.query<any, any>({
      query: () => ({
        url: endpoints.userProfile.url,
        method: endpoints.userProfile.method,
      }),
      providesTags: ['UserProfile'],
    }),
  })
})

const slice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});


export const { actions: userProfileActions, reducer: userProfileReducer } = slice;

export const useUserProfileSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
    useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
    return { actions: slice.actions, ...api };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
